import { addBuildGlobalColor, setLayerName } from "@builder/store/slices/BuilderSlice/builderSlice";
import store from "@builder/store/store";
import { getCleanJSX, } from "@builder/utils/JSXtoBuilder";
import { getLayerById } from "./helpers";
import { getCurrentLayer } from "@builder/store/slices/BuilderSlice/builderHelpers";



export const seeJSXOfNode = (layerId?: string, nodeId?: string) => {
    let idToCheck = nodeId;
    const layerDetails = layerId ? getLayerById(layerId) : getCurrentLayer();
    const layer = layerDetails?.layer;
    if (!layer) {
        console.error("Layer not found");
        return null;
    }
    const cleanJSX = getCleanJSX(layer, idToCheck);
    return cleanJSX;
};


export const seeLayersNameAndType = (layerId?: string) => {
    const layerDetails = layerId ? getLayerById(layerId) : getCurrentLayer();
    const layer = layerDetails?.layer;
    if (!layer) {
        console.error("Layer not found");
        return null;
    }
    return `Current layer is "${layer.name}" of type ${layerDetails.type}`;
}

export const renameLayer = (layerId: string, name: string) => {
    const layerDetails = getLayerById(layerId);
    const layer = layerDetails?.layer;
    if (!layer) {
        console.error("Layer not found");
        return null;
    }
    store.dispatch(setLayerName({ type: layerDetails.type, index: layerDetails.index, name }));
    const updatedLayer = getLayerById(layerId);
    if (!updatedLayer) {
        console.error("Layer not found");
        return null;
    }
    return `Layer type ${updatedLayer.type} renamed to ${updatedLayer.layer.name}`;
}



export const getGlobalColors = () => {
    const globalColors = store.getState().builder?.build.extraAttributes?.buildGlobalColors;
    if (!globalColors) {
        return []
    }
    return globalColors.map((color: any) => {
        return {
            color: color.color,
            name: color.name,
            var: `var(--${color.id})`
        }
    });
}

export const createGlobalColor = (color: string, name: string) => {
    store.dispatch(addBuildGlobalColor({color, name}));
    //now find this new color by hex to get the var:
    const newColor = getGlobalColors().find(c => c.color === color);
    if (!newColor) {
        return `failed to add color ${name} to color scheme, just use it as hex ${color}`;
    }
    return `Global color ${name} created, use this var: ${newColor.var}`;
}
